import React, { useContext } from 'react'

import TextLineBanner from 'modules/Home/components/TextLineBanner'
import { RU } from 'constants/countries'
import { EVENT_CODES } from 'constants/sales'
import { LocalizationContext } from 'contexts/Localization'
import useCurrentPromoEvent from 'hooks/useCurrentPromoEvent'

const PRODUCT_TEXT_LINE_SLIDE = {
  textLineContent: [
    { type: 'startMolecule' },
    { type: 'text', html: 'Начните знакомство с собой', fixedSize: true },
    { type: 'startMolecule' },
    { type: 'text', html: 'Промокод <span style="color:#faff95">СТАРТ</span> - 1000 ₽', fixedSize: true },
  ],
  textLineBg: '#9ac9e6',
  textLineColor: '#fff',
  textLineHref: null,
  textLineRepeat: 12,
  textLineDuration: 90,
}

const ProductTextLineBanner = () => {
  const { locale } = useContext(LocalizationContext)
  const event = useCurrentPromoEvent(locale)

  if (locale !== RU || event?.code !== EVENT_CODES.JUNE_BUNDLE_26) {
    return null
  }

  return <TextLineBanner slide={PRODUCT_TEXT_LINE_SLIDE} />
}

export default ProductTextLineBanner
